export const semesterLabel = (semester) => {
  return semester === 1 ? 'Spring' : semester === 2 ? 'Summer' : semester === 3 ? 'Autumn' : '';
};